import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import {
  getSubheadingValue,
  getSuggestionIcon,
  getSuggestionValue,
} from '../../searchControlHelper';

import type { AutosuggestSuggestion } from '../../../types';
import type { Maybe } from '@shared/types/utils';

import STYLES from './PopularDestination.module.scss';

export type Props = {
  index: number;
  onSuggestionSelected: Function;
  onBlur: Function;
  popular: AutosuggestSuggestion;
  isMobile?: boolean;
  onSuggestionsClearRequested?: Maybe<Function>;
};

const cls = cssModules(STYLES);

const PopularDestination = ({
  index,
  isMobile,
  onBlur,
  onSuggestionSelected,
  onSuggestionsClearRequested,
  popular,
}: Props) => {
  const Icon = getSuggestionIcon(popular);

  const handleSelection = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onSuggestionSelected(
      {},
      {
        suggestion: popular,
        suggestionIndex: index,
        suggestionValue: popular.entity,
        method: 'click',
        isPopularDestination: true,
      },
    );
    onBlur(e, {
      highlightedSuggestion: popular,
    });

    if (onSuggestionsClearRequested) {
      onSuggestionsClearRequested();
    }
  };

  return (
    <button
      className={cls('PopularDestination')}
      type="button"
      onClick={handleSelection}
    >
      {isMobile ? (
        getSuggestionValue(popular)
      ) : (
        <>
          <Icon className={cls('PopularDestination__icon')} />
          <div className={cls('PopularDestination__inner')}>
            <BpkText
              tagName="p"
              className={cls('PopularDestination__value')}
              color={TEXT_COLORS.textPrimary}
            >
              {getSuggestionValue(popular)}
            </BpkText>
            <BpkText
              textStyle={TEXT_STYLES.caption}
              tagName="p"
              className={cls('PopularDestination__subHeading')}
              color={TEXT_COLORS.textPrimary}
            >
              {getSubheadingValue(popular)}
            </BpkText>
          </div>
        </>
      )}
    </button>
  );
};

export default PopularDestination;
